/**
 * Collection Load More and Product Count Script
 */

const loadMoreSelectors = {
  id: {
      collectionGrid: "blog-articles",
      loadMoreBtn: "load_more_btn",
      loadMoreSpinner: "load_more_spinner"
  }
}

const collectionGrid = document.getElementById(loadMoreSelectors.id.collectionGrid);
const loadMoreBtn = document.getElementById(loadMoreSelectors.id.loadMoreBtn);
const loadMoreSpinner = document.getElementById(loadMoreSelectors.id.loadMoreSpinner);
let nextUrl = collectionGrid.getAttribute("data-next-url");

function loadMoreProducts () {
  loadMoreBtn.style.display = 'none';
  loadMoreSpinner.style.display = 'block';

  fetch(nextUrl).then(function (response) {
      // The API call was successful!
      return response.text();
  }).then(function (html) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, 'text/html');
      let newProducts = doc.getElementById(loadMoreSelectors.id.collectionGrid).getElementsByTagName("li");
      let newUrl = doc.getElementById(loadMoreSelectors.id.collectionGrid).getAttribute("data-next-url");

      nextUrl = newUrl; 
      loadMoreSpinner.style.display = 'none';

      if(nextUrl ? loadMoreBtn.style.display = 'block' : '');

      for (var i = 0; i < newProducts.length; i++) {
          collectionGrid.innerHTML += newProducts[i].outerHTML;
      }
      
      productCounter();
  }).catch(function (err) {
      console.warn('Something went wrong.', err);
  });
}

function productCounter () {
  let current_count = document.getElementById('product_current_count');
  let collection_items = Array.from(collectionGrid.querySelectorAll("LI"));

  current_count.textContent = collection_items.length;
}

window.onload = function(){
  productCounter();
}